import React from 'react';
import ErrorBoundaries from '../../../components/ErrorBoundaries';
import AllRanksTable from './components/AllRanksTable';

function RankPage() {
  return (
    <ErrorBoundaries>
      <AllRanksTable />
    </ErrorBoundaries>
  );
}

export default RankPage;
